module.exports = __webpack_public_path__ + "static/media/hero-poster-image.f80fd4c3.jpg";